<template>
	<div>
		<active ref="active" search=""  :type="filter" :city="site"></active>
		<backTop ref="bt"></backTop>
	</div>
</template>

<script>
	import active from '../publicComponents/active.vue';
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {
		components: {
			"active":active,
		},
		computed: {
			...mapState(['site']),
		},
		created(){
			this.filter=this.$route.query.type;
			this.wxShare();
		},
		data() {
			return {
				filter:"",
				isFirstEnter:false,
			}
		},
		methods:{
			reload() {
				this.filter = '';
			    this.$refs.active.reload();
			},
		},
		beforeRouteEnter(to, from, next) {
			if (from.name == 'detail') {
				to.meta.isBack = true;
			};
			next();
		},
		activated() {
			if (!this.$route.meta.isBack || this.isFirstEnter) {
				 this.reload();
			} else {
			}
			this.$route.meta.isBack = false
			this.isFirstEnter = false;
		},
		}
</script>

<style>
</style>
